import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import './LevelTag.scss'
import level1 from './images/level1.svg'
import level2 from './images/level2.svg'
import level3 from './images/level3.svg'
import level4 from './images/level4.svg'

export const LevelTag = ({
  level = '',
  className = '',
  technology = '',
  t,
}) => {
  const levelIcons = {
    1: level1,
    2: level2,
    3: level3,
    4: level4,
  }
  const levelIcon = levelIcons[level]
  const levelTechnology = t(`general.technology-themes.${technology}`, {
    defaultValue: '',
  })
  const levelText = t(`general.level-tag.${level}`, { defaultValue: '' })

  return (
    <>
      {levelIcon && (
        <div className={className}>
          <div className="c-level-tag">
            <img className="c-level-tag__icon" src={levelIcon} alt="" />
            {levelTechnology && levelText && (
              <span className="c-level-tag__text">
                {levelTechnology}: {levelText}
              </span>
            )}
          </div>
        </div>
      )}
    </>
  )
}

LevelTag.propTypes = {
  className: PropTypes.string,
  level: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  t: PropTypes.func.isRequired,
  technology: PropTypes.string,
}

export default withTranslation('translations')(LevelTag)
